import { DefaultService } from "@/api/SolarCloudApi";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { QueryConfig } from "@/lib/react-query";

export default function getTermsAndConditionsQueryOptions() {
  return queryOptions({
    queryKey: ["termsAndConditions"],
    queryFn: getTermsAndConditions,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });
}

async function getTermsAndConditions() {
  const response = await DefaultService.termsAndConditionsGetAcive();
  return response.collection ?? [];
}

type useTermsAndConditionsOptions = {
  queryConfig?: QueryConfig<typeof getTermsAndConditionsQueryOptions>;
};

export function useTermsAndConditions({
  queryConfig,
}: useTermsAndConditionsOptions = {}) {
  return useQuery({
    ...getTermsAndConditionsQueryOptions(),
    ...queryConfig,
  });
}
